import "./Home.css";
import { ArrowDown, ArrowUpRight, Github, Mail } from "lucide-react";
import { FaLinkedin } from 'react-icons/fa';
import Projects from "./Projects";
import Career from "./Career";


function Home() {
  return <main>
    <section id="top" className="hero section-shell">
      <p className="eyebrow">PORTFOLIO</p>
      <div className="hero-content">
        <h1>Caleb<br /><em>Fynewever</em></h1>
        <div className="hero-intro">
          <p>Hi I'm Caleb, and I love to code.</p>
          <div className="hero-links">
            <a href="mailto:caleb.fynewever@gmail.com"><Mail size={16} /> Get in touch</a>
            <a href="https://github.com/caleb-fynewever" target="_blank" rel="noreferrer"><Github size={16} /> GitHub</a>
            <a href="https://linkedin.com/in/calebfynewever" target="_blank" rel="noreferrer"><FaLinkedin size={16} /> LinkedIn</a>
          </div>
        </div>
      </div>
      <button className="scroll-cue" onClick={() => document.getElementById("projects")?.scrollIntoView({ behavior: "smooth" })}><ArrowDown size={17} /> Scroll</button>
    </section>
    <section id="projects" className="work-section section-shell">
      <div className="section-heading">
        <div>
          <p className="eyebrow">PROJECTS</p><h2>Things I've built.</h2>
        </div>
      </div>
      <Projects />
    </section>
    <section id="career" className="career-section section-shell">
      <div className="section-heading">
        <div>
          <p className="eyebrow">CAREER</p><h2>The path so far.</h2>
        </div>
      </div>
      <Career />
    </section>
    <footer className="site-footer section-shell">
      <p>Built by Caleb Fynewever</p>
      <a href="mailto:caleb.fynewever@gmail.com">Say hello! <ArrowUpRight size={16} /></a>
    </footer>
  </main>;
}
export default Home;
